import type { FC, PropsWithChildren } from 'react';
import { FALLBACK_SCOPE, ScopeContext } from './ScopeContext';

const TEST_NURSING_HOME = {
  id: 'test',
  name: 'Test nursing home',
  legalEntityId: 'test',
  pdfLogoId: 'test',
  paymentsDisabled: false,
  featureFlags: [],
  minPaymentAmountInCents: 50,
  maxPaymentAmountInCents: 500,
  minPaymentAmountInCentsEmployeeInitiated: 1,
  maxPaymentAmountInCentsEmployeeInitiated: 2500,
  minResidentThresholdsValue: 0,
  maxResidentThresholdsValue: 500,
};

const TEST_SCOPE = {
  ...FALLBACK_SCOPE,
  selectedNursingHome: TEST_NURSING_HOME,
  nursingHomeList: [],
};

export const TestScopeProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ScopeContext.Provider value={TEST_SCOPE}>{children}</ScopeContext.Provider>
  );
};
